import { render, staticRenderFns } from "./FacultyCoeHome.vue?vue&type=template&id=96b719a0&scoped=true"
import script from "./FacultyCoeHome.vue?vue&type=script&lang=js"
export * from "./FacultyCoeHome.vue?vue&type=script&lang=js"
import style0 from "./FacultyCoeHome.vue?vue&type=style&index=0&id=96b719a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b719a0",
  null
  
)

export default component.exports